export default {
  getDeviceList: {
    method: 'get',
    url: 'device'
  },
  remoteDevice: {
    method: 'post',
    url: 'device/remote'
  },
  getAuditRule: {
    method: 'get',
    url: 'platform/audit/rule'
  },
  setAuditRule: {
    method: 'post',
    url: 'platform/audit/rule'
  },
}
